import { render, staticRenderFns } from "./AboutGalaxy.vue?vue&type=template&id=1590da97&"
import script from "./AboutGalaxy.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AboutGalaxy.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports